import { render } from "./BreakDown.vue?vue&type=template&id=1ea8b6b7&scoped=true"
import script from "./BreakDown.vue?vue&type=script&lang=js"
export * from "./BreakDown.vue?vue&type=script&lang=js"

import "./BreakDown.vue?vue&type=style&index=0&id=1ea8b6b7&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea8b6b7"]])

export default __exports__